import { useMemo } from "react"

export function useSearchItems<TId extends string | number, T extends {id?: TId; name: string}> (
    items: T[],
    value: string,
    getSearchValue?: (item: T) => string
) {
    return useMemo(() => {
        const normalizedValue = value.trim().toLocaleLowerCase()

        if(!normalizedValue){
            return items
        }

        return items.filter(
            item => (getSearchValue?.(item) ?? item.name)
                .toLocaleLowerCase()
                .includes(normalizedValue)
        )
    }, [value, items, getSearchValue])
}
